import React, { useState } from "react";
import DestinationSelect from "./DestinationSelect";
import Modal from "react-modal";
import { ChildrenAgeSelect } from "./PersonSelect";
import AirportSelect from "./AirportSelect";
import Timeframe from "../components/Timeframe";
import Popup from "reactjs-popup";
import InfoPopup from "../components/InfoPopup";
import { memotosearch } from "amadeusredux/lib/api";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import de from "date-fns/locale/de";
import Calendar from "react-calendar";
import AirportIataSelect from "./AirportIataSelect";
import { fetchFares } from "amadeusredux/lib/flightSlice";
import Select from "react-select";

import CategoryFilter from "../filters/CategoryFilter";
import RecommendationFilter from "../filters/RecommendationFilter";

import { useSelector, useDispatch } from "react-redux";
import { durationOptions } from "amadeusredux/lib/utils";

//import configData from "../config.json";

import {
  selectSearch,
  setSearchOption,
  setSelectedDestination,
  setHolidayType,
  setOutbounddate,
  resetSearch,
  setInbounddate,
} from "amadeusredux/lib/searchSlice";

import { resetFilter } from "amadeusredux/lib/searchSlice";

import { search } from "amadeusredux/lib/api";
import {
  setHotelOfferInfos,
  setSelectedHotel,
} from "amadeusredux/lib/hotelSlice";
import MapModal from "../components/MapModal.js";

import {
  airportcity,
  childrenAgeOptions,
  commonDivisors,
  crtobr,
  getHost,
  views,
} from "../utils";
import {
  setSaveSearch,
  setSidebar,
  setView,
} from "amadeusredux/lib/systemSlice";

import { FaMinusCircle, FaBlog } from "react-icons/fa";
import { FaBackspace } from "react-icons/fa";
import { adultsOptions } from "../utils";
import { childrenOptions } from "../utils";

import { GoDiffAdded } from "react-icons/go";
import { GoDiffRemoved } from "react-icons/go";

import {
  getDepartures,
  getSuggestions,
  setOfferlistfilter,
  setSessionOptions,
} from "amadeusredux/lib/filterSlice";
import { useCookies } from "react-cookie";
import InfoPopupHover from "../components/InfoPopupHover";
import { deletesessionhistory } from "amadeusredux/lib/propertiesSlice";
import { setOfferInfos } from "amadeusredux/lib/offersSlice";
import { RiCloseFill } from "react-icons/ri";
import { GiConsoleController } from "react-icons/gi";
import FlightFilter from "../filters/FlightFilter.js";

export default function SearchFrameMain(props) {
  const { smallForm, memo, recognised, setRecognised, currentText } = props;

  const selectedDestination = useSelector(
    (state) => state.search.selectedDestination
  );

  const sessionHistory = useSelector(
    (state) => state.properties.sessionHistory
  );
  const hotel = useSelector((state) => state.hotel.selectedHotel);
  const holidayType = useSelector((state) => state.search.holidayType);
  const urlfound = useSelector((state) => state.system.urlfound);
  const features = useSelector((state) => state.system.features);
  const couponcode = useSelector((state) => state.search.couponcode);
  const oneway = useSelector((state) => state.search.oneway);
  const directflight = useSelector((state) => state.search.directflight);
  const outbounddate = useSelector((state) => state.search.outbounddate);
  const searchtest = useSelector((state) => state.search);
  const searchOptions = useSelector(selectSearch);
  const dispatch = useDispatch();
  const view = useSelector((state) => state.system.view);
  const sidebar = useSelector((state) => state.system.sidebar);
  const agencyprops = useSelector((state) => state.properties.agencyproperties);

  const [extendedView, setExtendedView] = React.useState("infos");
  const [shareOptionsHidden, setShareOptionsHidden] = React.useState(true);

  const transportOperators = useSelector(
    (state) => state.filter.transportOperators
  );
  const airlines = useSelector((state) => state.properties.airlines);
  const offerInfos = useSelector((state) => state.offers.offerInfos);
  const [mapOpen, setMapOpen] = useState(false);
  const [filterOpen, setfilterOpen] = useState(false);
  const [step, setStep] = useState(0);
  const [timeframeOpen, setTimeframeOpen] = useState(false);
  const [suggestOpen, setSuggestOpen] = useState(false);
  const [optionsOpen, setOptionsOpen] = useState(false);
  const [initialTravelers, setInitialTravelers] = useState(true);
  const [stateHoliday, setStateHoliday] = useState([]);
  const [bundeslaender, setBundeslaender] = useState([]);
  const [choice, setChoice] = useState("flex");
  const [flightdev, setFlightdev] = useState(true);
  const [flightdirect, setFlightdirect] = useState(false);
  const [travelClass, setTravelClass] = useState({
    value: "Economy",
    label: "Economy",
  });
  const [lastDuration, setLastDuration] = useState({
    value: "7",
    label: "1 Woche",
  });

  const [multiRooms, setMultiRooms] = React.useState([]);
  const multiroomdivider = useSelector(
    (state) => state.search.multiroomdivider
  );
  const [startView, setStartView] = useState(
    searchOptions?.travelDate?.from
      ? new Date(searchOptions.travelDate.from.split('"').join(""))
      : new Date()
  );
  const [endView, setEndView] = useState(
    searchOptions?.travelDate?.to
      ? new Date(searchOptions.travelDate.to.split('"').join(""))
      : new Date()
  );

  const customstyles = {
    control: (base) => ({
      ...base,
    }),
  };

  let today = new Date();
  let offers = offerInfos.Offers ? offerInfos.Offers.Offer : [];
  if (startView < today) {
    let dateFrom = new Date();
    dateFrom.setDate(today.getDate() + 7);
    setStartView(dateFrom);
    let dateUntil = new Date();
    dateUntil.setDate(today.getDate() + 14);
    setEndView(dateUntil);
  }

  if (endView < startView) {
    let dateUntil = new Date();
    dateUntil.setTime(startView.getTime);
    dateUntil.setDate(dateUntil.getDate() + 7);
    setEndView(dateUntil);
  }

  const [bundesland, setBundesland] = useState("");
  const [endDate, setEndDate] = useState(false);

  const times = [];
  for (let i = 0; i < 30; i++) {
    times.push(i + 1);
  }

  let destinationAirlines = transportOperators.map((e) => {
    let a = airlines.find((f) => e.value === f.value);
    return { ...e, properties: a ? a.properties : {} };
  });

  const getStates = () => {
    fetch(getHost() + "/holiday?request=laender")
      .then((response) => response.json())
      .then((data) => {
        //        console.log(data);
        setBundeslaender(data.ret);
        console.log(data.ret);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };
  const sessionId = useSelector((state) => state.system.sessionId);
  const travelorpopup = React.createRef();
  const calendarpopup = React.createRef();
  const durationpopup = React.createRef();
  const destinationref = React.createRef();
  const airportref = React.createRef();
  let childAges = Array.from(Array(searchOptions.children.value * 1).keys());
  registerLocale(de);
  const infos = useSelector((state) => state.properties.infos);

  const [width, setWidth] = useState(window.innerWidth);

  const changeClientFilter = (property, value) => {
    dispatch(setSearchOption({ property: property, data: value }));
  };

  const changeFilterAndSearch = (property, value) => {
    dispatch(setSearchOption({ property: property, data: value }));
  };

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  React.useEffect(() => {
    getStates();

    setMultiRooms(
      commonDivisors(
        searchOptions?.adults?.value * 1,
        searchOptions?.children?.value * 1 === 0
          ? searchOptions?.adults?.value * 1
          : searchOptions?.children?.value * 1
      )
    );

    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, [searchOptions.adults.value, searchOptions.children.value]);

  React.useEffect(() => {
    getStates();

    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const isMobileWidth = width <= 768;

  const showAll = true;

  const holidays = (isocode) => {
    //fetch("https://aws.placelogg.com/api/holiday?request=publicholidays&land=DE-BY")
    fetch(getHost() + "/holiday?request=schoolholidays&land=" + isocode)
      .then((response) => response.json())
      .then((data) => {
        //console.log("test");
        //console.log(data);
        setStateHoliday(data.ret);
        console.log(data.ret);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  let allHolidays = [];

  if (searchOptions) {
    if (
      new Date(searchOptions.travelDate.from.split('"').join("")).getTime() <
      new Date().getTime()
    ) {
      let dur;
      if (typeof searchOptions.duration.value === "string") {
        let tmp = searchOptions.duration.value.split("-")[1];
        if (tmp) {
          dur = parseInt(tmp);
        } else {
          dur = parseInt(searchOptions.duration.value);
        }
      } else {
        dur = searchOptions.duration.value;
      }

      let tmpdatefrom = new Date();
      tmpdatefrom.setDate(tmpdatefrom.getDate() + 1);
      let tmpdateto = new Date();
      tmpdateto.setDate(tmpdatefrom.getDate() + dur);
      dispatch(
        setSearchOption({
          property: "travelDate",
          data: {
            from: JSON.stringify(tmpdatefrom),

            to: JSON.stringify(tmpdateto),
          },
        })
      );

      console.log(new Date(searchOptions.travelDate.from.split('"').join("")));
    }
  }

  if (stateHoliday.length > 0) {
    //console.log(stateHoliday);
    for (let i = 0; i < stateHoliday.length; i++) {
      if (stateHoliday[i].startdate !== stateHoliday[i].enddate) {
        const start = new Date(stateHoliday[i].startdate);
        const end = new Date(stateHoliday[i].enddate);
        //console.log(start);
        //console.log(end);

        const date = new Date(new Date(stateHoliday[i].startdate).getTime());
        while (date <= end) {
          allHolidays.push({
            date: format(date, "yyyy-MM-dd", {
              locale: de,
            }),
            name: stateHoliday[i].name,
          });
          date.setDate(date.getDate() + 1);
        }
      } else {
        allHolidays.push({
          date: stateHoliday[i].start,
          name: stateHoliday[i].name,
        });
      }
    }
    //console.log(allHolidays);
  }

  //const testcountdown = <div id="countdowntest"/>;
  /*var script = document.createElement("script");
  script.setAttribute("type", "text/javascript");
  var stextnode = document.createTextNode('var countDownDate = new Date("Jan 5, 2025 15:37:25").getTime();var x = setInterval(function() {var now = new Date().getTime();var distance = countDownDate - now;var days = Math.floor(distance / (1000 * 60 * 60 * 24));var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)); var seconds = Math.floor((distance % (1000 * 60)) / 1000);document.getElementById("countdowntest").innerHTML = days + "d " + hours + "h "+ minutes + "m " + seconds + "s ";}, 1000);');
 */ /* script.value =
    'var countDownDate = new Date("Jan 5, 2025 15:37:25").getTime();var x = setInterval(function() {var now = new Date().getTime();var distance = countDownDate - now;var days = Math.floor(distance / (1000 * 60 * 60 * 24));var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)); var seconds = Math.floor((distance % (1000 * 60)) / 1000);document.getElementById("countdowntest").innerHTML = days + "d " + hours + "h "+ minutes + "m " + seconds + "s ";}}, 1000);';
  */
  /*script.appendChild(stextnode);
  if (document.getElementById('countdowntest')!=null){
    document.getElementById('countdowntest').appendChild(script);
    console.log(script.value);
  };*/
  if (!(view.searchview || views.tileview)) {
    if (!sidebar) {
      return <></>;
      /*return (
      <div
        style={{
          padding: smallForm ? "32px 0px 16px 16px" : 16,
        }}
      >
        <span
          className="expand"
          style={{ cursor: "pointer" }}
          onClick={() => dispatch(setSidebar(true))}
        >
          <FaSearch />
        </span>
      </div>
    );*/
    }
  }
  //console.log(searchOptions.children.value);
  const doSearch = () => {
    //if (smallForm)
    dispatch(setOfferlistfilter(""));

    //console.log(view);
    if (
      window.location.href.indexOf(window.configData.RESULTS_URL) === -1 ||
      isMobileWidth
    ) {
      //let qid = new Date().getTime() + "";
      let url = window.configData.RESULTS_URL;
      //if (isMobileWidth) url = "https://app.holiserver.com/mobile/";
      //url = "http://localhost:3000/";
      /*if (!holidayType.flight)
        url = window.configData.RESULTS_URL;
*/
      //console.log(url);
      try {
        fetch(getHost() + "/searchattributes", {
          method: "post",
          body: JSON.stringify(searchOptions),
          headers: new Headers({
            "content-type": "application/json",
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            if (url.indexOf("?") > -1) {
              url =
                url +
                "&flights=" +
                (holidayType.flight ? "1" : "0") +
                "&qid=" +
                data.qid;
            } else {
              url =
                url +
                "?flights=" +
                (holidayType.flight ? "1" : "0") +
                "&qid=" +
                data.qid;
            }
            window.location.href = url;
          });
      } catch (e) {
        console.log(e);
      }
      return;
    }

    dispatch(setSaveSearch(true));
    dispatch(setSidebar(false));
    //console.log("12234",selectedDestination);
    if (selectedDestination.length > 0) {
      if (selectedDestination[0].HotelID) {
        dispatch(setOutbounddate(""));
        dispatch(setInbounddate(""));
        dispatch(setSelectedHotel(selectedDestination[0]));
        search(dispatch, true, false);
        dispatch(setView(views.hotelcrossview));
      } else {
        dispatch(setOutbounddate(""));
        dispatch(setInbounddate(""));
        search(dispatch, false, false);
        dispatch(setView(views.offerview));
      }
    }
    dispatch(setSaveSearch(false));
  };

  console.log(searchOptions);

  return (
    <React.Fragment>
      {view !== views.tileview && view !== views.searchview && (
        <>
          <span
            className="collapse"
            style={{ cursor: "pointer" }}
            onClick={() => dispatch(setSidebar(false))}
          >
            <FaMinusCircle />
          </span>
        </>
      )}
      {/*<Timeframe open={timeframeOpen} setOpen={setTimeframeOpen} />*/}

      <Suggest
        setRecognised={(txt) => setRecognised(txt)}
        currentText={currentText}
        recognised={recognised}
        open={suggestOpen}
        setOpen={setSuggestOpen}
      />
      <Options open={optionsOpen} setOpen={setOptionsOpen} />

      {!urlfound && (
        <div style={{ display: "flex" }} className="searchtabs">
          {" "}
          <div
            className={
              "searchtab " +
              (holidayType.flight && holidayType.accommodation
                ? "searchtabactive"
                : "")
            }
            onClick={() => {
              if (
                view === views.hotelclassicview ||
                view === views.hotelcrossview
              ) {
                try {
                  fetch(getHost() + "/searchattributes", {
                    method: "post",
                    body: JSON.stringify({
                      searchOptions,
                      hotel,
                      outbounddate: outbounddate,
                      offer: {},
                    }),
                    headers: new Headers({
                      "content-type": "application/json",
                    }),
                  })
                    .then((response) => response.json())
                    .then((data) => {
                      let url = window.configData.RESULTS_URL;
                      if (url.indexOf("?") > -1) {
                        url =
                          url +
                          "&flights=1" +
                          "&hv=" +
                          (view === views.hotelclassicview
                            ? "classic"
                            : "crosscheck") +
                          "&nqid=" +
                          data.qid;
                      } else {
                        url =
                          url +
                          "?flights=1" +
                          "&hv=" +
                          (view === views.hotelclassicview
                            ? "classic"
                            : "crosscheck") +
                          "&nqid=" +
                          data.qid;
                      }
                      window.open(url, "_blank", "noreferrer");
                    });
                } catch (e) {
                  console.log(e);
                }
                return;
              }

              let search = false;
              dispatch(setHolidayType({ accommodation: true, flight: true }));
              if (Array.isArray(offers) && offers.length > 0) search = true;

              dispatch(setOfferInfos({}));
              dispatch(setHotelOfferInfos({}));
              //dispatch(setView(views.searchview));

              dispatch(
                setSearchOption({
                  property: "durationkind",
                  data: {
                    value: "Trip",
                  },
                })
              );

              if (search) doSearch();
            }}
          >
            Pauschalreise{" "}
          </div>{" "}
          {/*flightdev && (
            <div
              className={
                "searchtab " +
                (holidayType.flight && !holidayType.accommodation
                  ? "searchtabactive"
                  : "")
              }
              onClick={() => {
                dispatch(
                  setHolidayType({ accommodation: false, flight: true })
                );
                dispatch(setOfferInfos({}));
                dispatch(setHotelOfferInfos({}));
                dispatch(setView(views.searchview));
                dispatch(
                  setSearchOption({
                    property: "durationkind",
                    data: {
                      value: "OvernightStays",
                    },
                  })
                );
              }}
            >
              {" "}
              Nur Flug{" "}
            </div>
          )*/}{" "}
          <div
            className={
              "searchtab " + (holidayType.flight ? "" : "searchtabactive")
            }
            onClick={() => {
              if (
                view === views.hotelclassicview ||
                view === views.hotelcrossview
              ) {
                try {
                  fetch(getHost() + "/searchattributes", {
                    method: "post",
                    body: JSON.stringify({
                      searchOptions,
                      hotel,
                      outbounddate: outbounddate,
                      offer: {},
                    }),
                    headers: new Headers({
                      "content-type": "application/json",
                    }),
                  })
                    .then((response) => response.json())
                    .then((data) => {
                      let url = window.configData.RESULTS_URL;
                      if (url.indexOf("?") > -1) {
                        url =
                          url +
                          "&flights=0" +
                          "&hv=" +
                          (view === views.hotelclassicview
                            ? "classic"
                            : "crosscheck") +
                          "&nqid=" +
                          data.qid;
                      } else {
                        url =
                          url +
                          "?flights=0" +
                          "&hv=" +
                          (view === views.hotelclassicview
                            ? "classic"
                            : "crosscheck") +
                          "&nqid=" +
                          data.qid;
                      }
                      window.open(url, "_blank", "noreferrer");
                    });
                } catch (e) {
                  console.log(e);
                }
                return;
              }

              let search = false;
              dispatch(setHolidayType({ accommodation: true, flight: false }));
              if (Array.isArray(offers) && offers.length > 0) search = true;
              dispatch(setOfferInfos({}));
              dispatch(setHotelOfferInfos({}));
              //dispatch(setView(views.searchview));
              dispatch(
                setSearchOption({
                  property: "durationkind",
                  data: {
                    value: "OvernightStays",
                  },
                })
              );
              if (search) doSearch();
            }}
          >
            {" "}
            {!agencyprops?.properties?.justhotel && "Nur Unterkunft"}
            {agencyprops?.properties?.justhotel && (
              <>{agencyprops?.properties?.justhotel}</>
            )}{" "}
          </div>{" "}
        </div>
      )}

      <div className="newframe">
        {holidayType.flight && !holidayType.accommodation && (
          <>
            <div className="newframe4flight">
              <FlightFilter
                destinationAirlines={destinationAirlines}
              ></FlightFilter>
            </div>
            {/*<div className="newframe4flight">
            <div className="flightframe">
            </div>
            <div className="flightframe">
              <div className="flightcheck">
                <input
                  className="flightradio"
                  type="radio"
                  checked={!oneway}
                  onChange={() =>
                    dispatch(
                      setSearchOption({ property: "oneway", data: false })
                    )
                  }
                ></input>
                <div className="flighttext">Hin- und Rückflug</div>
              </div>
            </div>
            <div className="flightframe">
              <div className="flightcheck">
                <input
                  className="flightradio"
                  type="radio"
                  checked={oneway}
                  onChange={() =>
                    dispatch(
                      setSearchOption({ property: "oneway", data: true })
                    )
                  }
                ></input>
                <div className="flighttext">Nur Hinflug</div>
              </div>
            </div>
            <div className="flightframe">
              <div className="flightcheck">
                <input
                  className="flightradio"
                  type="radio"
                  disabled
                  checked={false}
                ></input>
                <div className="flighttext">Gabelflug</div>
              </div>
            </div>
            <div className="flightframe">
              <div className="flightcheck2">
                <Select
                  value={travelClass}
                  onChange={(e) => {
                    setTravelClass(e);
                  }}
                  options={[
                    { value: "Economy", label: "Economy" },
                    { value: "Business", label: "Business" },
                  ]}
                ></Select>
              </div>
            </div>
            <div className="flightframe">
              <div className="flightcheck">
                <input
                  className="flightradio"
                  type="checkbox"
                  checked={directflight}
                  onChange={() =>
                    dispatch(
                      setSearchOption({
                        property: "directflight",
                        data: !directflight,
                      })
                    )
                  }
                ></input>
                <div className="flighttext">Nur Direktflüge</div>
              </div>
            </div>
          </div>*/}
          </>
        )}
        <div className={isMobileWidth ? "newframe4mobile" : "newframe4"}>
          {!(holidayType.flight && !holidayType.accommodation) && (
            <div className={isMobileWidth ? "newframe2mobile" : "newframe2"}>
              <div className="newframe12">Reiseziel</div>
              <DestinationSelect
                step={step}
                setStep={setStep}
                nextRef={airportref}
                className="newframe5"
                currentInput={selectedDestination.length < 1}
              />
            </div>
          )}
          {holidayType.flight && !holidayType.accommodation && (
            <>
              <div className={isMobileWidth ? "newframe2mobile" : "newframe2"}>
                <div className="newframe14">
                  <div className="newframe12">Von</div>
                  {/*!isMobileWidth && (
                    <Popup
                      modal
                      trigger={(open) => (
                        <div
                          style={{ marginBottom: 3.2 }}
                          className={"selectAll searchframe7 "}
                        >
                          Kartenansicht
                        </div>
                      )}
                    >
                      {(close) => (
                        <MapModal
                          handleClose={() => {
                            close();
                            if (step === 0) {
                              setStep(1);
                            }
                          }}
                        ></MapModal>
                      )}
                    </Popup>
                  )*/}
                </div>
                {holidayType.accommodation && (
                  <AirportSelect
                    step={step}
                    setStep={setStep}
                    thisRef={airportref}
                    currentInput={
                      holidayType?.flight
                        ? searchOptions?.stations?.length < 1
                        : false
                    }
                  />
                )}
                {!holidayType.accommodation && (
                  <AirportIataSelect isDisabled={false} stationindex={0} />
                )}
              </div>
            </>
          )}
          {holidayType.flight && holidayType.accommodation && (
            <>
              <div className={isMobileWidth ? "newframe2mobile" : "newframe2"}>
                <div className="newframe14">
                  <div className="newframe12">Abflughafen</div>
                  {!isMobileWidth && (
                    <Popup
                      modal
                      trigger={(open) => (
                        <div
                          style={{ marginBottom: 3.2 }}
                          className={
                            "selectAll searchframe7 " +
                            (selectedDestination.length < 1
                              ? "searchframe7disabled"
                              : "")
                          }
                        >
                          Kartenansicht
                        </div>
                      )}
                    >
                      {(close) => (
                        <MapModal
                          handleClose={() => {
                            close();
                            if (selectedDestination.length > 0 && step === 1) {
                              setStep(2);
                            }
                          }}
                        ></MapModal>
                      )}
                    </Popup>
                  )}
                </div>
                <AirportSelect
                  step={step}
                  setStep={setStep}
                  thisRef={airportref}
                  isDisabled={selectedDestination.length < 1}
                  currentInput={
                    holidayType?.flight
                      ? searchOptions?.stations?.length < 1 &&
                        selectedDestination.length > 0
                      : false
                  }
                />
              </div>
            </>
          )}
          {holidayType.flight && !holidayType.accommodation && (
            <>
              <div className={isMobileWidth ? "newframe2mobile" : "newframe2"}>
                <div className="newframe14">
                  <div className="newframe12">Nach</div>
                  {/*!isMobileWidth && (
                    <Popup
                      modal
                      trigger={(open) => (
                        <div
                          style={{ marginBottom: 3.2 }}
                          className={
                            "selectAll searchframe7 " +
                            (selectedDestination.length < 1
                              ? "searchframe7disabled"
                              : "")
                          }
                        >
                          Kartenansicht
                        </div>
                      )}
                    >
                      {(close) => (
                        <MapModal
                          handleClose={() => {
                            close();
                            if (selectedDestination.length > 0 && step === 1) {
                              setStep(2);
                            }
                          }}
                        ></MapModal>
                      )}
                    </Popup>
                  )*/}
                </div>

                <AirportIataSelect isDisabled={false} stationindex={1} />
              </div>
            </>
          )}
          <div className={isMobileWidth ? "newframe2mobile" : "newframe2"}>
            <div className="newframe6">
              <div className="newframe12">
                <div style={{ width: "100%", display: "flex" }}>
                  <div style={{ flexGrow: 1 }}>Reisende</div>
                  <div style={{ flexShrink: 1 }}>
                    {features && (
                      <>
                        <span
                          className="collapse"
                          style={{ cursor: "pointer" }}
                          onClick={() => setSuggestOpen(true)}
                        >
                          <FaBlog />
                        </span>
                      </>
                    )}
                    {features && (
                      <>
                        <span
                          className="collapse"
                          style={{ cursor: "pointer" }}
                          onClick={() => setOptionsOpen(true)}
                        >
                          <FaBlog />
                        </span>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <Popup
                ref={travelorpopup}
                /*</div>open={
                  (holidayType?.flight ? step === 2 : step === 1) &&
                  initialTravelers &&
                  (holidayType?.flight
                    ? searchOptions?.stations?.length > 0 &&
                      selectedDestination.length > 0
                    : selectedDestination.length > 0)
                }*/
                contentStyle={{ backgroundColor: "white" }}
                onClose={() => {
                  setInitialTravelers(false);
                  if (holidayType?.flight ? step === 2 : step === 1) {
                    setStep(3);
                  }
                }}
                trigger={(open) => (
                  <div
                    className={
                      (step === 2 &&
                      (holidayType?.flight
                        ? searchOptions?.stations?.length > 0 &&
                          selectedDestination.length > 0
                        : selectedDestination.length > 0)
                        ? "currentInput "
                        : "standardInput ") +
                      ((
                        holidayType?.flight
                          ? searchOptions?.stations?.length < 1 ||
                            selectedDestination.length < 1
                          : selectedDestination.length < 1
                      )
                        ? "travDisabled"
                        : "travEnabled")
                    }
                  >
                    <InfoPopupHover
                      trigger={
                        <div>
                          <input
                            readOnly="readonly"
                            disabled={
                              holidayType?.flight
                                ? searchOptions?.stations?.length < 1
                                : selectedDestination.length < 1
                            }
                            className={
                              (
                                holidayType?.flight
                                  ? searchOptions?.stations?.length < 1 &&
                                    selectedDestination.length < 1
                                  : selectedDestination.length < 1
                              )
                                ? "newframe20disabled"
                                : "newframe20"
                            }
                            type="text"
                            value={
                              searchOptions?.adults?.label +
                              ", " +
                              searchOptions?.children?.label +
                              " " +
                              (parseInt(searchOptions?.children?.value) > 0
                                ? searchOptions.childrenages.every(
                                    (o, i) =>
                                      i >=
                                        parseInt(
                                          searchOptions?.children.value
                                        ) || parseInt(o.value) > 0
                                  )
                                  ? "(" +
                                    searchOptions.childrenages
                                      .slice(
                                        0,
                                        parseInt(searchOptions.children.value)
                                      )
                                      .map((o, i) => o.label)
                                      .join(", ") +
                                    ")"
                                  : " (Bitte Alter aller Kinder angeben)"
                                : "")
                            }
                          ></input>
                        </div>
                      }
                      content={
                        searchOptions?.adults?.label +
                        ", " +
                        searchOptions?.children?.label +
                        " " +
                        (parseInt(searchOptions?.children?.value) > 0
                          ? searchOptions.childrenages.every(
                              (o, i) =>
                                i >= parseInt(searchOptions?.children.value) ||
                                parseInt(o.value) > 0
                            )
                            ? "(" +
                              searchOptions.childrenages
                                .slice(
                                  0,
                                  parseInt(searchOptions.children.value)
                                )
                                .map((o, i) => o.label)
                                .join(", ") +
                              ")"
                            : " (Bitte Alter aller Kinder angeben)"
                          : "")
                      }
                      position={"left top"}
                    ></InfoPopupHover>
                  </div>
                )}
              >
                <div className="travelorpopup">
                  <div className="travelorpopupstart">
                    <div className="travelorpopup3">Erwachsene</div>
                    <div className="travelorpopup2">
                      <div
                        className={
                          parseInt(searchOptions?.adults?.value) !== 1
                            ? "travelorpopup10"
                            : "travelorpopupdisabled"
                        }
                      >
                        <GoDiffRemoved
                          className={
                            parseInt(searchOptions?.adults?.value) !== 1
                              ? "travelorpopupicon"
                              : "travelorpopupicondisabled"
                          }
                          onClick={() => {
                            dispatch(
                              setSearchOption({
                                property: "multiroomdivider",
                                data: 1,
                              })
                            );

                            if (parseInt(searchOptions?.adults?.value) !== 1) {
                              dispatch(
                                setSearchOption({
                                  property: "adults",
                                  data: adultsOptions[
                                    parseInt(searchOptions?.adults?.value) - 2
                                  ],
                                })
                              );
                            }
                          }}
                        ></GoDiffRemoved>
                      </div>
                      <div className="travelorpopup11">
                        <div className="travelorpopup12">
                          {searchOptions?.adults?.value}
                        </div>
                      </div>
                      <div
                        className={
                          parseInt(searchOptions?.adults?.value) !== 6
                            ? "travelorpopup10"
                            : "travelorpopupdisabled"
                        }
                      >
                        <GoDiffAdded
                          className={
                            parseInt(searchOptions?.adults?.value) !== 6
                              ? "travelorpopupicon"
                              : "travelorpopupicondisabled"
                          }
                          onClick={() => {
                            if (parseInt(searchOptions?.adults?.value) !== 6) {
                              dispatch(
                                setSearchOption({
                                  property: "multiroomdivider",
                                  data: 1,
                                })
                              );

                              dispatch(
                                setSearchOption({
                                  property: "adults",
                                  data: adultsOptions[
                                    parseInt(searchOptions?.adults?.value)
                                  ],
                                })
                              );
                            }
                          }}
                        ></GoDiffAdded>
                      </div>
                    </div>
                  </div>
                  <div className="travelorpopup1">
                    <div className="travelorpopup3">Kinder</div>
                    <div className="travelorpopup2">
                      <div
                        className={
                          parseInt(searchOptions?.children?.value) !== 0
                            ? "travelorpopup10"
                            : "travelorpopupdisabled"
                        }
                      >
                        <GoDiffRemoved
                          className={
                            parseInt(searchOptions?.children?.value) !== 0
                              ? "travelorpopupicon"
                              : "travelorpopupicondisabled"
                          }
                          onClick={() => {
                            if (
                              parseInt(searchOptions?.children?.value) !== 0
                            ) {
                              dispatch(
                                setSearchOption({
                                  property: "multiroomdivider",
                                  data: 1,
                                })
                              );

                              dispatch(
                                setSearchOption({
                                  property: "children",
                                  data: childrenOptions[
                                    parseInt(searchOptions?.children?.value) - 1
                                  ],
                                })
                              );
                            }
                          }}
                        ></GoDiffRemoved>
                      </div>
                      <div className="travelorpopup11">
                        <div className="travelorpopup12">
                          {searchOptions?.children?.value}
                        </div>
                      </div>
                      <div
                        className={
                          parseInt(searchOptions?.children?.value) !== 4
                            ? "travelorpopup10"
                            : "travelorpopupdisabled"
                        }
                      >
                        <GoDiffAdded
                          className={
                            parseInt(searchOptions?.children?.value) !== 4
                              ? "travelorpopupicon"
                              : "travelorpopupicondisabled"
                          }
                          onClick={() => {
                            if (
                              parseInt(searchOptions?.children?.value) !== 4
                            ) {
                              dispatch(
                                setSearchOption({
                                  property: "multiroomdivider",
                                  data: 1,
                                })
                              );

                              dispatch(
                                setSearchOption({
                                  property: "children",
                                  data: childrenOptions[
                                    parseInt(searchOptions?.children?.value) + 1
                                  ],
                                })
                              );
                            }
                          }}
                        ></GoDiffAdded>
                      </div>
                    </div>
                  </div>
                  {searchOptions?.children?.value > 0 && (
                    <div className="travelorpopup13">
                      Kindesalter bei Rückreise
                    </div>
                  )}
                  {[...Array(parseInt(searchOptions.children.value))].map(
                    (o, i) => {
                      return (
                        <div key={i} style={{ marginBottom: "5px" }}>
                          <ChildrenAgeSelect index={i} />
                        </div>
                      );
                    }
                  )}

                  {multiRooms.map((e) => {
                    let adultsCount = searchOptions?.adults?.value * 1;
                    let childrenCount = searchOptions?.children?.value * 1;

                    return (
                      <div style={{ margin: "20px" }}>
                        <div
                          class="form-check"
                          style={{ fontSize: "15pt", display: "flex" }}
                        >
                          <div style={{ marginRight: "10px" }}>
                            <input
                              style={{
                                width: "15pt",
                                height: "15pt",
                                marginTop: "5px",
                              }}
                              class="form-check-input"
                              type="radio"
                              checked={multiroomdivider === e}
                              name="multiroomcheck"
                              id={"multiroomradio" + e}
                              onClick={() => {
                                dispatch(
                                  setSearchOption({
                                    property: "multiroomdivider",
                                    data: e,
                                  })
                                );
                              }}
                            />{" "}
                          </div>
                          <div>
                            <label
                              class="form-check-label"
                              for={"multiroomradio" + e}
                            >
                              {e} Zimmer mit {e > 1 ? "je" : ""}
                              <br></br>
                              {adultsCount / e}{" "}
                              {adultsCount / e > 1
                                ? "Erwachsenen"
                                : "Erwachsener"}
                              {childrenCount > 0 ? " und " : ""}
                              <br></br>
                              {childrenCount > 0
                                ? childrenCount / e +
                                  (childrenCount / e > 1 ? " Kindern" : " Kind")
                                : ""}
                            </label>
                          </div>
                        </div>
                      </div>
                    );
                  })}

                  <div className="travelorpopup14">
                    <span
                      className={
                        parseInt(searchOptions?.children?.value) < 1
                          ? "travelorpopup15"
                          : searchOptions.childrenages.every(
                              (o, i) =>
                                i >= parseInt(searchOptions?.children.value) ||
                                parseInt(o.value) > 0
                            )
                          ? "travelorpopup15"
                          : "travelorpopup15disabled"
                      }
                      onClick={() => travelorpopup.current.close()}
                    >
                      Übernehmen
                    </span>
                  </div>
                </div>
              </Popup>
            </div>

            {/*<div className="newframe6">
              <div className="newframe12">Reisende (Kinder)</div>
              <select>
                <div style={{width:"100px",height:"100px"}}></div>
              </select>
              <ChildrenSelect />
              {(searchOptions.children.value > 0) && (<><div className="newframe12"> Kindesalter bei Rückreise:</div>{
                [...Array(parseInt(searchOptions.children.value))].map((o, i) => {
                  return (<div style={{ marginBottom: "5px" }}>
                    <ChildrenAgeSelect index={i} /></div>)
                })
              }</>)}
            </div>*/}
          </div>

          {/*PLACEHOLDER*/}
        </div>
        <div className={isMobileWidth ? "newframe4mobile" : "newframe4"}>
          <div className={isMobileWidth ? "newframe2mobile" : "newframe2"}>
            <div className="newframe6">
              <div className="newframe12">Reisezeitraum</div>{" "}
              <Popup
                position="bottom center"
                ref={calendarpopup}
                open={
                  step === 3 &&
                  (holidayType?.flight
                    ? searchOptions?.stations?.length > 0 &&
                      selectedDestination.length > 0
                    : selectedDestination.length > 0)
                }
                contentStyle={{ backgroundColor: "white" }}
                onClose={() => {
                  if (step === 3) {
                    setStep(4);
                  }
                }}
                trigger={(open) => (
                  <div className="standardInput">
                    <InfoPopupHover
                      trigger={
                        <div>
                          <input
                            readOnly="readonly"
                            className="newframe20"
                            type="text"
                            value={
                              holidayType.flight &&
                              !holidayType.accommodation &&
                              oneway
                                ? format(
                                    new Date(
                                      searchOptions.travelDate.from
                                        .split('"')
                                        .join("")
                                    ),
                                    "do MMMM Y",
                                    {
                                      locale: de,
                                    }
                                  )
                                : format(
                                    new Date(
                                      searchOptions.travelDate.from
                                        .split('"')
                                        .join("")
                                    ),
                                    "do MMMM Y",
                                    {
                                      locale: de,
                                    }
                                  ) +
                                  " - " +
                                  (searchOptions.travelDate.to
                                    ? format(
                                        new Date(
                                          searchOptions.travelDate.to
                                            .split('"')
                                            .join("")
                                        ),
                                        "do MMMM Y",
                                        {
                                          locale: de,
                                        }
                                      )
                                    : "")
                            }
                          ></input>
                        </div>
                      }
                      content={
                        holidayType.flight &&
                        !holidayType.accommodation &&
                        oneway
                          ? format(
                              new Date(
                                searchOptions.travelDate.from
                                  .split('"')
                                  .join("")
                              ),
                              "do MMMM Y",
                              {
                                locale: de,
                              }
                            )
                          : format(
                              new Date(
                                searchOptions.travelDate.from
                                  .split('"')
                                  .join("")
                              ),
                              "do MMMM Y",
                              {
                                locale: de,
                              }
                            ) +
                            " - " +
                            (searchOptions.travelDate.to
                              ? format(
                                  new Date(
                                    searchOptions.travelDate.to
                                      .split('"')
                                      .join("")
                                  ),
                                  "do MMMM Y",
                                  {
                                    locale: de,
                                  }
                                )
                              : "")
                      }
                      position={"right top"}
                    ></InfoPopupHover>
                  </div>
                )}
              >
                <div className="timeframepopup">
                  <div style={{ display: "flex" }}>
                    <Calendar
                      selectRange={
                        !(
                          holidayType.flight &&
                          !holidayType.accommodation &&
                          oneway
                        )
                      }
                      showNeighboringMonth={false}
                      showDoubleView={
                        !(
                          holidayType.flight &&
                          !holidayType.accommodation &&
                          oneway
                        )
                      }
                      activeStartDate={startView}
                      onActiveStartDateChange={({
                        action,
                        activeStartDate,
                        value,
                        view,
                      }) => {
                        setStartView(activeStartDate);
                        let tmpdate = new Date(activeStartDate);
                        setEndView(
                          new Date(tmpdate.setMonth(tmpdate.getMonth() + 1))
                        );
                      }}
                      minDate={new Date()}
                      className="timeframe13"
                      tileClassName={({ date, view }) => {
                        let result = "";
                        if (
                          allHolidays.find((x) => {
                            return (
                              x.date ===
                              format(date, "yyyy-MM-dd", { locale: de })
                            );
                          })
                        ) {
                          result = result + "highlight ";
                        }
                        if (
                          date.getTime() ===
                          new Date(
                            searchOptions.travelDate.from.split('"').join("")
                          ).getTime()
                        ) {
                          result = result + "calendar_start ";
                        }
                        if (
                          date.getTime() ===
                          new Date(
                            new Date(
                              searchOptions.travelDate.to.split('"').join("")
                            ).setHours(0, 0, 0, 0)
                          ).getTime()
                        ) {
                          result = result + "calendar_end ";
                        }
                        return result;
                      }}
                      onChange={(update) => {
                        let updateArr = update;
                        if (
                          holidayType.flight &&
                          !holidayType.accommodation &&
                          oneway
                        ) {
                          let date2 = new Date(update);
                          date2.setDate(date2.getDate() + 7);
                          console.log(date2);
                          updateArr = [update, date2];
                        }

                        let dur;
                        if (typeof searchOptions.duration.value === "string") {
                          let tmp = searchOptions.duration.value.split("-")[1];
                          if (tmp) {
                            dur = parseInt(tmp);
                          } else {
                            dur = parseInt(searchOptions.duration.value);
                          }
                        } else {
                          dur = searchOptions.duration.value;
                        }
                        let newdur = Math.ceil(
                          (updateArr[1].getTime() - updateArr[0].getTime()) /
                            (1000 * 3600 * 24)
                        );
                        if (dur > newdur) {
                          dispatch(
                            setSearchOption({
                              property: "duration",
                              data: {
                                value: newdur,
                                label: durationOptions[newdur].label,
                              },
                            })
                          );
                        }
                        dispatch(
                          setSearchOption({
                            property: "travelDate",
                            data: {
                              from: updateArr
                                ? JSON.stringify(updateArr[0])
                                : undefined,
                              to: updateArr
                                ? JSON.stringify(updateArr[1])
                                : undefined,
                            },
                          })
                        );
                        console.log(searchOptions.duration);
                      }}
                      value={
                        searchOptions.travelDate
                          ? [
                              searchOptions.travelDate.from
                                ? new Date(
                                    searchOptions.travelDate.from
                                      .split('"')
                                      .join("")
                                  )
                                : undefined,
                              searchOptions.travelDate.to
                                ? !(
                                    holidayType.flight &&
                                    !holidayType.accommodation &&
                                    oneway
                                  )
                                  ? new Date(
                                      searchOptions.travelDate.to
                                        .split('"')
                                        .join("")
                                    )
                                  : undefined
                                : undefined,
                            ]
                          : undefined
                      }
                    />
                  </div>
                  <div
                    className={
                      isMobileWidth ? "timeframe19mobile" : "timeframe19"
                    }
                  >
                    <div
                      className={
                        isMobileWidth ? "timeframe18mobile" : "timeframe18"
                      }
                    >
                      <div className="timeframe14">
                        Schulferien anzeigen für
                      </div>
                      <div>
                        <select
                          className="timeframe15"
                          onChange={(e) => holidays(e.target.value)}
                        >
                          <option hidden>bitte auswählen</option>
                          {bundeslaender.map((o, i) => {
                            return (
                              <option key={o.isocode} value={o.isocode}>
                                {o.name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>
                    {stateHoliday.length > 0 && (
                      <div
                        className={
                          isMobileWidth ? "timeframe18mobile" : "timeframe18"
                        }
                      >
                        <div className="timeframe14">Ferien</div>
                        <div>
                          <select
                            className="timeframe15"
                            onChange={(e) => {
                              //console.log(e);
                              let selectedHoliday = e.target.value.split("|");
                              //console.log(selectedHoliday);
                              for (let i = 0; i < stateHoliday.length; i++) {
                                if (
                                  selectedHoliday[0] == stateHoliday[i].name &&
                                  selectedHoliday[1] * 1 ==
                                    new Date(
                                      stateHoliday[i].startdate
                                    ).getFullYear()
                                ) {
                                  setStartView(
                                    new Date(stateHoliday[i].startdate) <
                                      new Date()
                                      ? new Date()
                                      : new Date(stateHoliday[i].startdate)
                                  );
                                  setEndView(new Date(stateHoliday[i].enddate));
                                  dispatch(
                                    setSearchOption({
                                      property: "travelDate",
                                      data: {
                                        to: JSON.stringify(
                                          new Date(stateHoliday[i].enddate)
                                        ),
                                        from: JSON.stringify(
                                          new Date(stateHoliday[i].startdate) <
                                            new Date()
                                            ? new Date()
                                            : new Date(
                                                stateHoliday[i].startdate
                                              )
                                        ),
                                      },
                                    })
                                  );
                                }
                              }
                            }}
                          >
                            <option hidden>bitte auswählen</option>
                            {stateHoliday.map((o, i) => {
                              return (
                                <option
                                  key={
                                    o.name +
                                    "|" +
                                    new Date(o.startdate).getFullYear()
                                  }
                                  value={
                                    o.name +
                                    "|" +
                                    new Date(o.startdate).getFullYear()
                                  }
                                >
                                  {o.name} {new Date(o.startdate).getFullYear()}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="travelorpopup14">
                    <span
                      className={
                        parseInt(searchOptions?.children?.value) < 1
                          ? "travelorpopup15"
                          : searchOptions.childrenages.every(
                              (o, i) =>
                                i >= parseInt(searchOptions?.children.value) ||
                                parseInt(o.value) > 0
                            )
                          ? "travelorpopup15"
                          : "travelorpopup15disabled"
                      }
                      onClick={() => calendarpopup.current.close()}
                    >
                      Übernehmen
                    </span>
                  </div>
                </div>
              </Popup>
            </div>
          </div>
          {holidayType.accommodation && (
            <div className={isMobileWidth ? "newframe2mobile" : "newframe2b"}>
              <div className="newframe6">
                <div className="newframe12">Reisedauer</div>{" "}
                <Popup
                  position="bottom center"
                  ref={durationpopup}
                  open={
                    step === 4 &&
                    (holidayType?.flight
                      ? searchOptions?.stations?.length > 0 &&
                        selectedDestination.length > 0
                      : selectedDestination.length > 0)
                  }
                  contentStyle={{ backgroundColor: "white" }}
                  onClose={() => {
                    if (step === 4) {
                      setStep(5);
                    }
                  }}
                  trigger={(open) => (
                    <div className="standardInput">
                      <InfoPopupHover
                        trigger={
                          <div>
                            {" "}
                            <input
                              readOnly="readonly"
                              className="newframe20"
                              type="text"
                              value={searchOptions?.duration?.label}
                            ></input>
                          </div>
                        }
                        content={searchOptions?.duration?.label}
                        position={"left top"}
                      ></InfoPopupHover>
                    </div>
                  )}
                >
                  <div className="timeframepopup">
                    <div>
                      <div
                        className={
                          isMobileWidth
                            ? "travelframe22mobile"
                            : "travelframe22"
                        }
                      >
                        <div className="timeframe7">Reisetermin</div>
                        <div>
                          <div className="timeframe21">
                            <div
                              className={
                                isMobileWidth
                                  ? "timeframe10mobile"
                                  : "timeframe10"
                              }
                            >
                              <input
                                type="checkbox"
                                checked={choice === "flex"}
                                onChange={() => {
                                  setChoice("flex");
                                  dispatch(
                                    setSearchOption({
                                      property: "duration",
                                      data: lastDuration,
                                    })
                                  );
                                  let tmpdatecompare = new Date(
                                    new Date(
                                      searchOptions.travelDate.to
                                        .split('"')
                                        .join("")
                                    )
                                  );
                                  let tmpdate = new Date(
                                    new Date(
                                      searchOptions.travelDate.from
                                        .split('"')
                                        .join("")
                                    )
                                  );
                                  /*console.log(
                                  durationOptions[lastDuration.value].value
                                );*/
                                  let tmpdate2 = new Date(
                                    tmpdate.setDate(
                                      tmpdate.getDate() +
                                        durationOptions[lastDuration.value]
                                          .value
                                    )
                                  );
                                  /*setEndView(tmpdate2);*/
                                  dispatch(
                                    setSearchOption({
                                      property: "travelDate",
                                      data: {
                                        from: searchOptions.travelDate.from,
                                        to:
                                          tmpdate2 < tmpdatecompare
                                            ? searchOptions.travelDate.to
                                            : JSON.stringify(tmpdate2),
                                      },
                                    })
                                  );
                                }}
                              ></input>

                              <div className="timeframe12">flexibel</div>
                            </div>
                          </div>
                          <div className="timeframe21">
                            <div
                              className={
                                isMobileWidth
                                  ? "timeframe11mobile"
                                  : "timeframe11"
                              }
                            >
                              <input
                                type="checkbox"
                                checked={choice === "exact"}
                                onChange={() => {
                                  if (choice != "exact") {
                                    setLastDuration(searchOptions.duration);
                                  }
                                  setChoice("exact");
                                  dispatch(
                                    setSearchOption({
                                      property: "duration",
                                      data: {
                                        value: "0.1",
                                        label: "exakt wie angegeben",
                                      },
                                    })
                                  );
                                }}
                              ></input>
                              <div className="timeframe12">genau am</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {holidayType.flight && (
                        <div
                          className={
                            isMobileWidth
                              ? "travelframe22mobile"
                              : "travelframe22"
                          }
                        >
                          <div>Reisedauerart</div>
                          <div>
                            <div className="timeframe21">
                              <div
                                className={
                                  isMobileWidth
                                    ? "timeframe10mobile"
                                    : "timeframe10"
                                }
                              >
                                <input
                                  checked={
                                    searchOptions?.durationkind?.value ===
                                    "Trip"
                                  }
                                  type="checkbox"
                                  onChange={() => {
                                    dispatch(
                                      setSearchOption({
                                        property: "durationkind",
                                        data: {
                                          value: "Trip",
                                          label: "Reisedauer",
                                        },
                                      })
                                    );
                                  }}
                                ></input>

                                <div className="timeframe12">Tage</div>
                              </div>
                            </div>
                            <div className="timeframe21">
                              <div
                                className={
                                  isMobileWidth
                                    ? "timeframe11mobile"
                                    : "timeframe11"
                                }
                              >
                                <input
                                  checked={
                                    searchOptions?.durationkind?.value ===
                                    "Stay"
                                  }
                                  type="checkbox"
                                  onChange={() => {
                                    dispatch(
                                      setSearchOption({
                                        property: "durationkind",
                                        data: {
                                          value: "Stay",
                                          label: "Aufenthalt",
                                        },
                                      })
                                    );
                                  }}
                                ></input>
                                <div className="timeframe12">Nächte</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      <div
                        className={
                          isMobileWidth ? "timeframe22mobile" : "travelframe22"
                        }
                      >
                        <div>Reisedauer</div>
                        <div>
                          <select
                            disabled={choice === "exact"}
                            onChange={(e) => {
                              if (e.target.value === "0.1") {
                                setLastDuration(searchOptions.duration);
                                setChoice("exact");
                              }

                              let tmpdate = new Date(
                                new Date(
                                  searchOptions.travelDate.from
                                    .split('"')
                                    .join("")
                                )
                              );
                              let tmpdatecompare = new Date(
                                new Date(
                                  searchOptions.travelDate.to
                                    .split('"')
                                    .join("")
                                )
                              );
                              let tmpdate2 = new Date(
                                tmpdate.setDate(
                                  tmpdate.getDate() +
                                    durationOptions[e.target.value].value
                                )
                              );
                              console.log(e.target.value);

                              /*setEndView(tmpdate2);*/
                              dispatch(
                                setSearchOption({
                                  property: "duration",
                                  data: {
                                    value: e.target.value,
                                    label:
                                      durationOptions[e.target.value].label,
                                  },
                                })
                              );
                              dispatch(
                                setSearchOption({
                                  property: "travelDate",
                                  data: {
                                    from: searchOptions.travelDate.from,
                                    to:
                                      tmpdate2 < tmpdatecompare
                                        ? searchOptions.travelDate.to
                                        : JSON.stringify(tmpdate2),
                                  },
                                })
                              );
                            }}
                            value={searchOptions?.duration?.value}
                          >
                            {holidayType.flight && (
                              <>
                                <option value={0.1}>exakt wie angegeben</option>
                                <option value={0.2}>beliebig</option>
                                <option value={7}>1 Woche</option>
                                <option value={14}>2 Wochen</option>
                                <option value={21}>3 Wochen</option>
                              </>
                            )}
                            <option value={"3-4"}>3-4 Tage</option>
                            <option value={"5-7"}>5-7 Tage</option>
                            <option value={"8-10"}>8-10 Tage</option>
                            <option value={"11-13"}>11-13 Tage</option>
                            <option value={"14-16"}>14-16 Tage</option>
                            {times.map((o, i) => {
                              return (
                                <option key={o} value={o}>
                                  {!holidayType.flight
                                    ? o === 1
                                      ? "" + o + " Übernachtung"
                                      : "" + o + " Übernachtungen"
                                    : o === 1
                                    ? "" + o + " Tag"
                                    : "" + o + " Tage"}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="travelorpopup14">
                      <span
                        className={
                          parseInt(searchOptions?.children?.value) < 1
                            ? "travelorpopup15"
                            : searchOptions.childrenages.every(
                                (o, i) =>
                                  i >=
                                    parseInt(searchOptions?.children.value) ||
                                  parseInt(o.value) > 0
                              )
                            ? "travelorpopup15"
                            : "travelorpopup15disabled"
                        }
                        onClick={() => durationpopup.current.close()}
                      >
                        Übernehmen
                      </span>
                    </div>
                  </div>
                </Popup>
              </div>
            </div>
          )}
          <div
            className={isMobileWidth ? "newframe8mobile" : "newframe2"}
            style={{ display: "flex" }}
          >
            {!isMobileWidth && (
              <InfoPopupHover
                trigger={
                  <>
                    <div style={{ flexGrow: 1 }}>
                      <div className="newframe6">
                        <div
                          className="newframe12"
                          style={{ visibility: "hidden" }}
                        >
                          .
                        </div>{" "}
                        <button
                          disabled={
                            selectedDestination.length < 1 ||
                            holidayType?.flight
                              ? searchOptions?.stations?.length < 1
                              : false
                          }
                          className={
                            selectedDestination.length < 1 ||
                            (holidayType?.flight
                              ? searchOptions?.stations?.length < 1
                              : false) ||
                            !searchOptions.childrenages.every(
                              (o, i) =>
                                i >= parseInt(searchOptions?.children.value) ||
                                parseInt(o.value) > 0
                            )
                              ? isMobileWidth
                                ? "newframe11disabledmobile"
                                : "newframe11disabled"
                              : isMobileWidth
                              ? "newframe11mobile"
                              : "newframe11"
                          }
                          onClick={() => {
                            if (
                              holidayType.flight &&
                              !holidayType.accommodation
                            ) {
                              dispatch(fetchFares());
                              dispatch(setView(views.flightsview));
                              return;
                            }
                            doSearch();
                          }}
                        >
                          Reise finden
                        </button>
                      </div>
                    </div>
                  </>
                }
                content={
                  selectedDestination.length < 1 ||
                  (holidayType?.flight
                    ? searchOptions?.stations?.length < 1
                    : false) ||
                  !searchOptions.childrenages.every(
                    (o, i) =>
                      i >= parseInt(searchOptions?.children.value) ||
                      parseInt(o.value) > 0
                  )
                    ? "Bitte geben Sie folgende Informationen an:<br>" +
                      (selectedDestination.length < 1
                        ? "- mindestens ein <b>Reiseziel</b> <br>"
                        : "") +
                      (holidayType?.flight
                        ? searchOptions?.stations?.length < 1
                          ? "- mindestens einen <b>Abflughafen</b> <br>"
                          : ""
                        : "") +
                      (!searchOptions.childrenages.every(
                        (o, i) =>
                          i >= parseInt(searchOptions?.children.value) ||
                          parseInt(o.value) > 0
                      )
                        ? "- das Alter aller Kinder"
                        : "")
                    : infos.searchframemain
                }
                position={"left top"}
              ></InfoPopupHover>
            )}

            <div className={isMobileWidth ? "newframe8mobile" : "newframe2c"}>
              <div className="newframe6">
                <div className="newframe12" style={{ visibility: "hidden" }}>
                  .
                </div>{" "}
                <InfoPopupHover
                  trigger={
                    <button
                      disabled={
                        selectedDestination.length < 1 &&
                        (holidayType?.flight
                          ? searchOptions?.stations?.length < 1
                          : true)
                      }
                      className={"buttonframe"}
                      onClick={() => {
                        dispatch(resetSearch());
                        /*dispatch(setSaveSearch(true));
                  dispatch(setSidebar(false));
                  if (selectedDestination.length > 0) {
                    if (selectedDestination[0].HotelID) {
                      dispatch(setOutbounddate(""));
                      dispatch(setInbounddate(""));
                      dispatch(setSelectedHotel(selectedDestination[0]));
                      search(dispatch, true, false);
                    } else {
                      dispatch(setOutbounddate(""));
                      dispatch(setInbounddate(""));
                      search(dispatch, false, false);
                      dispatch(setView(views.offerview));
                    }
                  }
                  dispatch(setSaveSearch(false));*/
                      }}
                    >
                      <div style={{ visibility: "hidden" }}>.</div>
                      <FaBackspace />
                      <div style={{ visibility: "hidden" }}>.</div>
                    </button>
                  }
                  content={"Suche zurücksetzen"}
                  position={"left top"}
                ></InfoPopupHover>
              </div>
            </div>
          </div>
          {/*<div className={isMobileWidth ? "newframe2mobile" : "newframe2"}>
            <button
              onClick={() => {
                console.log(agencyprops);
              }}
            >
              DeBUG
            </button>
            </div>*/}
        </div>
        <div className={isMobileWidth ? "newframe4mobile" : "newframe4"}>
          {/*<div className={isMobileWidth ? "newframe8mobile" : "newframe8"}>
            <button
              onClick={() => setTimeframeOpen(!timeframeOpen)}
              className={
                (
                  holidayType?.flight
                    ? searchOptions?.stations?.length > 0 &&
                      selectedDestination.length > 0
                    : selectedDestination.length > 0
                )
                  ? isMobileWidth
                    ? "newframe13mobile"
                    : "newframe13"
                  : isMobileWidth
                  ? "newframe13disabledmobile"
                  : "newframe13disabled"
              }
            >
              Reisedaten
            </button>
          </div>*/}
          {/*<div className={isMobileWidth ? "newframe8mobile" : "newframe8"}>
            <button
              onClick={() =>
                setExtendedView(extendedView === "filter" ? "infos" : "filter")
              }
              className={isMobileWidth ? "newframe21mobile" : "newframe21"}
            >
              Erweiterte Suche
            </button>
            </div>*/}

          {/*<div className={isMobileWidth ? "newframe8mobile" : "newframe8"}>
            <button
              onClick={() =>
                setExtendedView(
                  extendedView === "history" ? "infos" : "history"
                )
              }
              className={isMobileWidth ? "newframe21mobile" : "newframe21"}
            >
              Letzte Suchanfragen
            </button>
          </div>*/}
        </div>
        {/*
        <div className={isMobileWidth ? "newframe24mobile" : "newframe24"}>
          {extendedView === "infos" && (
            <div className={isMobileWidth ? "newframe25mobile" : "newframe25"}>
              <div className={isMobileWidth ? "newframe8mobile" : "newframe8"}>
                <div className="newframe12">Reisedauer</div>
                <input
                  className="newframe10"
                  type="text"
                  disabled
                  value={searchOptions?.duration?.label}
                ></input>
              </div>
              <div className={isMobileWidth ? "newframe8mobile" : "newframe8"}>
                <div className="newframe12">Früheste Hinreise</div>
                <input
                  className="newframe10"
                  type="text"
                  disabled
                  value={format(
                    new Date(searchOptions.travelDate.from.split('"').join("")),
                    "EE, do MMMM Y",
                    {
                      locale: de,
                    }
                  )}
                ></input>
              </div>
              <div className={isMobileWidth ? "newframe8mobile" : "newframe8"}>
                <div className="newframe12">Späteste Rückreise</div>
                <input
                  className="newframe10"
                  type="text"
                  disabled
                  value={format(
                    new Date(searchOptions.travelDate.to.split('"').join("")),
                    "EE, do MMMM Y",
                    {
                      locale: de,
                    }
                  )}
                ></input>
              </div>
            </div>
          )}
          {extendedView === "filter" && (
            <div className={isMobileWidth ? "newframe25mobile" : "newframe25"}>
              {" "}
              <div
                className={isMobileWidth ? "newframe22mobile" : "newframe22"}
              >
                <div
                  className={isMobileWidth ? "newframe8mobile" : "newframe23"}
                >
                  <CategoryFilter
                    classtype={"pricefilter2"}
                    changeFilterAndSearch={changeFilterAndSearch}
                  />
                </div>
                <div
                  className={isMobileWidth ? "newframe8mobile" : "newframe23"}
                >
                  <RecommendationFilter
                    classtype={"pricefilter2"}
                    changeFilterAndSearch={changeFilterAndSearch}
                  />
                </div>
                <div className={isMobileWidth ? "newframe8mobile" : "newframe23"}>
                  <RatingCountFilter
                    classtype={"pricefilter2"}
                    changeFilterAndSearch={changeFilterAndSearch}
                  />
          </div>
                <div
                  className={isMobileWidth ? "newframe8mobile" : "newframe23"}
                >
                  <div
                    className={"pricefilter2"}
                    style={{
                      display: "flex",
                      height: "100%",
                      justifyContent: "center",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={searchOptions.directflight}
                      onChange={() =>
                        dispatch(
                          changeFilterAndSearch(
                            "directflight",
                            !searchOptions.directflight
                          )
                        )
                      }
                    />{" "}
                    <div
                      style={{
                        marginRight: "10px",
                        marginLeft: "10px",
                        alignItems: "center",
                        display: "flex",
                        fontSize: "12pt",
                      }}
                    >
                      Direktflug
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {isMobileWidth && (
            <InfoPopupHover
              trigger={
                <div
                  className={isMobileWidth ? "newframe8mobile" : "newframe8"}
                >
                  <button
                    disabled={
                      selectedDestination.length < 1 || holidayType?.flight
                        ? searchOptions?.stations?.length < 1
                        : false
                    }
                    className={
                      selectedDestination.length < 1 ||
                      (holidayType?.flight
                        ? searchOptions?.stations?.length < 1
                        : false) ||
                      !searchOptions.childrenages.every(
                        (o, i) =>
                          i >= parseInt(searchOptions?.children.value) ||
                          parseInt(o.value) > 0
                      )
                        ? isMobileWidth
                          ? "newframe11disabledmobile"
                          : "newframe11disabled"
                        : isMobileWidth
                        ? "newframe11mobile"
                        : "newframe11"
                    }
                    onClick={() => doSearch()}
                  >
                    Reise finden
                  </button>
                </div>
              }
              content={
                selectedDestination.length < 1 ||
                (holidayType?.flight
                  ? searchOptions?.stations?.length < 1
                  : false) ||
                !searchOptions.childrenages.every(
                  (o, i) =>
                    i >= parseInt(searchOptions?.children.value) ||
                    parseInt(o.value) > 0
                )
                  ? "Bitte geben Sie folgende Informationen an:<br>" +
                    (selectedDestination.length < 1
                      ? "- mindestens ein <b>Reiseziel</b> <br>"
                      : "") +
                    (holidayType?.flight
                      ? searchOptions?.stations?.length < 1
                        ? "- mindestens einen <b>Abflughafen</b> <br>"
                        : ""
                      : "") +
                    (!searchOptions.childrenages.every(
                      (o, i) =>
                        i >= parseInt(searchOptions?.children.value) ||
                        parseInt(o.value) > 0
                    )
                      ? "- das Alter aller Kinder"
                      : "")
                  : infos.searchframemain
              }
              position={"bottom center"}
            ></InfoPopupHover>
          )}
            </div>*/}

        <div className="newframe4">
          {agencyprops?.properties?.request_couponcode && (
            <>
              <div
                className={isMobileWidth ? "newframe30mobile" : "newframe30"}
              >
                {" "}
                <div
                  dangerouslySetInnerHTML={{
                    __html: "" + infos.couponrequest,
                  }}
                />
              </div>
              <div className="newframe2">
                <div className="newframe6">
                  <div
                    className={
                      isMobileWidth ? "newframe2mobile" : "standardInput"
                    }
                  >
                    <input
                      className="newframe20"
                      type="text"
                      value={couponcode ? couponcode : ""}
                      onChange={(e) =>
                        dispatch(
                          setSearchOption({
                            property: "couponcode",
                            data: e.target.value,
                          })
                        )
                      }
                    ></input>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>

        <div className="newframe4">
          {agencyprops?.properties?.request_postcode && (
            <>
              <div
                className={isMobileWidth ? "newframe30mobile" : "newframe30"}
              >
                {" "}
                <div
                  dangerouslySetInnerHTML={{
                    __html: "" + infos.postcoderequest,
                  }}
                />
              </div>
              <div className="newframe2">
                <div className="newframe6">
                  <div
                    className={
                      isMobileWidth ? "newframe2mobile" : "standardInput"
                    }
                  >
                    <input
                      className="newframe20"
                      type="text"
                      value={couponcode ? couponcode : ""}
                      onChange={(e) =>
                        dispatch(
                          setSearchOption({
                            property: "postcode",
                            data: e.target.value,
                          })
                        )
                      }
                    ></input>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        {/*<div id="countdowntest"></div>*/}
      </div>

      <div className="newframe28">
        <div className={isMobileWidth ? "newframe27mobile" : "newframe27"}>
          {sessionHistory.map((e, i) => {
            //console.log(e);

            return (
              <div
                key={i}
                className={isMobileWidth ? "newframe8mobile" : "newframe8"}
              >
                <div
                  className={isMobileWidth ? "newframe26mobile" : "newframe26"}
                >
                  <div className="newframeclose">
                    <RiCloseFill
                      onClick={() => {
                        dispatch(deletesessionhistory(e));
                      }}
                      style={{ fontSize: "1.5rem", margin: "auto" }}
                    />
                  </div>
                  <div
                    onClick={() => {
                      if (
                        window.location.href.indexOf(
                          window.configData.RESULTS_URL
                        ) === -1
                      ) {
                        let url = window.configData.RESULTS_URL;

                        try {
                          fetch(getHost() + "/searchattributes", {
                            method: "post",
                            body: JSON.stringify(e),
                            headers: new Headers({
                              "content-type": "application/json",
                            }),
                          })
                            .then((response) => response.json())
                            .then((data) => {
                              if (url.indexOf("?") > -1) {
                                url =
                                  url +
                                  "&flights=" +
                                  (holidayType.flight ? "1" : "0") +
                                  "&hid=" +
                                  data.qid;
                              } else {
                                url =
                                  url +
                                  "?flights=" +
                                  (holidayType.flight ? "1" : "0") +
                                  "&hid=" +
                                  data.qid;
                              }
                              window.location.href = url;
                            });
                        } catch (ex) {
                          console.log(ex);
                        }
                        return;
                      }

                      let hotel = {
                        value: e.HotelName,
                        label: e.HotelName,
                        HotelCodes: e.HotelCodes,
                        Name: e.HotelName,
                      };
                      dispatch(resetFilter(views.searchview));
                      dispatch(setOutbounddate(""));
                      dispatch(setInbounddate(""));
                      dispatch(setSelectedDestination([hotel]));
                      dispatch(setSelectedHotel(hotel));
                      //console.log("E",e);
                      //if(1==1) return;
                      if (e.request?.stations) {
                        let reqstats = e.request.stations.split(",");
                        let stats = [];
                        for (let i = 0; i < reqstats.length; i++) {
                          stats.push({
                            value: reqstats[i],
                            label: airportcity(reqstats[i]),
                          });
                        }
                        dispatch(
                          setSearchOption({
                            property: "stations",
                            data: stats,
                          })
                        );
                      }

                      if (e.request?.adults)
                        dispatch(
                          setSearchOption({
                            property: "adults",
                            data: adultsOptions.find(
                              (o) => o.value === e.request.adults + ""
                            ),
                          })
                        );
                      if (e.request?.children) {
                        dispatch(
                          setSearchOption({
                            property: "children",
                            data: childrenOptions.find(
                              (o) => o.value === e.request.children + ""
                            ),
                          })
                        );

                        if (e.request?.childrenages) {
                          let childrenages = [
                            { value: "0", label: "Alter" },
                            { value: "0", label: "Alter" },
                            { value: "0", label: "Alter" },
                            { value: "0", label: "Alter" },
                            { value: "0", label: "Alter" },
                            { value: "0", label: "Alter" },
                            { value: "0", label: "Alter" },
                            { value: "0", label: "Alter" },
                            { value: "0", label: "Alter" },
                            { value: "0", label: "Alter" },
                          ];
                          let tmpages = e.request.childrenages.split(",");
                          if (Array.isArray(tmpages)) {
                            for (let i = 0; i < tmpages.length; i++) {
                              childrenages[i] = childrenAgeOptions.find(
                                (o) => o.value === tmpages[i] + ""
                              );
                            }
                          }
                          dispatch(
                            setSearchOption({
                              property: "childrenages",
                              data: childrenages,
                            })
                          );
                        }
                      }
                      //doSearch();
                      search(dispatch, true, false);
                      dispatch(setView(views.hotelcrossview));
                    }}
                  >
                    <span
                      style={{
                        width: "80%",
                        display: "block",
                        fontWeight: "bold",
                      }}
                    >
                      {e.HotelName}
                    </span>
                    <span
                      style={{
                        width: "100%",
                        display: "block",
                        fontStyle: "italic",
                      }}
                    >
                      in {e.HotelCity}{" "}
                    </span>
                    <span style={{ width: "100%", display: "block" }}>
                      {e.Remark}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </React.Fragment>
  );
}

function Suggest(props) {
  const { open, setOpen, recognised, setRecognised, currentText } = props;

  const [cookies, setCookie] = useCookies(["amadeussession"]);

  Modal.setAppElement("#root");
  const holidaySuggestions = useSelector(
    (state) => state.filter.holidaySuggestions
  );
  const infos = useSelector((state) => state.properties.infos);
  const departures = useSelector((state) => state.filter.departures);
  const dispatch = useDispatch();
  const getHolidaySuggestions = (text, zipcode) => {
    setCookie("zipcode", zipcode, {
      expires: new Date(2099, 1, 1),
      path: "/",
    });
    dispatch(getSuggestions({ text: text, zipcode: zipcode }));
  };
  const inputRef = React.useRef(null);
  const zipcodeRef = React.useRef(null);
  const [started, setStarted] = useState(false);
  const cityInfo = useSelector((state) => state.hotel.cityInfo);
  const [popupOpen, setPopupOpen] = React.useState(false);

  //console.log(infos);

  function recstart() {
    //console.log(window.recognition);
    window.recognition.start();

    /*if (!started) {
      window.recognition.start();
      setStarted(true);
    }
    else {
      window.recognition.stop();
      setStarted(false);
    }*/
  }

  return (
    <>
      <InfoPopup
        popupOpen={popupOpen}
        setPopupOpen={(val) => setPopupOpen(val)}
        text={
          Array.isArray(cityInfo) && cityInfo.length > 0
            ? cityInfo[0].klimainformationen
            : ""
        }
      />
      <Modal isOpen={open} className="">
        {/*infos.searchframemain*/}
        <div className="">
          <label>Ihre PLZ:</label>
          <input
            onBlur={(evt) => {
              dispatch(getDepartures({ zipcode: zipcodeRef.current.value }));
            }}
            defaultValue={cookies.zipcode ? cookies.zipcode : ""}
            ref={zipcodeRef}
          ></input>
          {Array.isArray(departures) && departures.length > 0 && (
            <>
              {" "}
              <br /> {departures[0].cityname} {departures[0].locationname}{" "}
              <br /> {departures[0].airports} {departures[0].stations} <br />
            </>
          )}
          <br />
          <label>
            Geben Sie uns hier wichtige Hinweise auf Ihre Urlaubswünsche:
          </label>
          <br />
          Welche Jahreszeit, Familie, Anzahl Kinder. Welche Gegend Sie
          bevorzugen und welche Ansprüche Sie stellen
          <br />
          Wir versuchen dann Ihnen optimale Vorschläge zu unterbreiten.
          <br />
          <textarea
            disabled={Array.isArray(departures) && departures.length == 0}
            onChange={(e) => setRecognised(e.target.value)}
            value={recognised}
            rows={10}
            cols={100}
            ref={inputRef}
          />
          <br />
          {currentText}
          <br />
          {holidaySuggestions.map((e, i) => {
            return (
              <div
                key={i}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  memotosearch({ ret: [{ ...e.data }] }, dispatch);
                  setOpen(false);
                }}
              >
                {i == 0 && (
                  <div>
                    <span style={{ fontWeight: 600, color: "red" }}>
                      {" "}
                      {crtobr(e.question)}
                      <br />
                      <br />
                    </span>
                    <span style={{ fontWeight: 300 }}>
                      {crtobr(e.description)}
                      <br />
                      <br />
                    </span>
                    <span style={{ fontWeight: 600, color: "black" }}>
                      {" "}
                      {e.reasons}
                      <br />
                      <br />
                    </span>
                  </div>
                )}
                {<span title={e.suggestion}>{e.text}</span>}
              </div>
            );
          })}
          <br />
          <button
            onClick={() => {
              setOpen(false);
            }}
          >
            Abbrechen
          </button>
          <button
            disabled={Array.isArray(departures) && departures.length == 0}
            onClick={() => {
              getHolidaySuggestions(
                inputRef.current.value,
                zipcodeRef.current.value
              );
              //setOpen(false);
            }}
          >
            Suggest
          </button>
          <span onClick={() => recstart()}> hören</span>
        </div>
      </Modal>
    </>
  );
}

function Options(props) {
  const { open, setOpen } = props;

  const inputRef = React.useRef(null);

  Modal.setAppElement("#root");
  const sessionOptions = useSelector((state) => state.filter.sessionOptions);

  const dispatch = useDispatch();
  const sendSessionOptions = (text) => {
    //console.log(text);
    try {
      JSON.parse(text);
    } catch (e) {
      //alert(e);
    }
    dispatch(setSessionOptions(JSON.parse(text)));
  };

  return (
    <>
      <Modal isOpen={open} className="">
        <div className="">
          <div>{sessionOptions && <>{JSON.stringify(sessionOptions)}</>}</div>
          <textarea rows={10} cols={100} ref={inputRef} />

          <button
            onClick={() => {
              setOpen(false);
            }}
          >
            Abbrechen
          </button>
          <button
            onClick={() => {
              sendSessionOptions(inputRef.current.value);
            }}
          >
            Send
          </button>
        </div>
      </Modal>
    </>
  );
}
